// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2wLJt","requiredAsterisk":"Info_requiredAsterisk__3dh6B"};